import React, { useState, useEffect } from 'react';
import fire from './components/Firebase'
import dp from './components/assets/dp.jpg'
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import Typewriter from 'typewriter-effect';
import About from './components/About'
import Contact from './components/Contact'
import Skills from './components/Skills'
import Work from './components/Work'
import Resume from './components/Resume'
import { FaUserTie, FaRegIdCard } from 'react-icons/fa'
import { GiSkills } from 'react-icons/gi'
import {MdWork, MdPhoneInTalk, MdLightMode, MdDarkMode} from 'react-icons/md'

function App() {
  const [dHeight, setDHeight] = useState('100vh')
  const themeColors = {
    darkOn: {
      textColor: '#f5f5f5',
      textColor1: '#cccccc',
      iam: 'white',
      bottomBorder: '#242424',
      main: {
        primary: '#18191a',
        secondary: '#2E7D32'
      },
      container: {
        primary: '#242526',
        secondary: '#3a3b3c'
      }
    },
    darkOff: {
      textColor: '#2e2e2e',
      textColor1: '#4f4f4f',
      iam: 'black',
      bottomBorder: '#f7f7f7',
      main: {
        primary: '#f0f2f5',
        secondary: '#c9c9c9'
      },
      container: {
        primary: '#ffffff',
        secondary: '#f0f2f5'
      }
    }
  }
  const [darkMode, setDarkMode] = useState(true)
  const [section, setSection] = useState('work')
  // const [dp, setDp] = useState('')

  const updateHeight = () => {
    setDHeight(window.innerHeight)
  }

  useEffect(() => {
    window.addEventListener("resize", updateHeight)
    setDHeight(window.innerHeight)
  }, [dHeight])

  // useEffect(() => {
  //   fire.storage().ref('assets/dp.png').getDownloadURL().then((url) => {
  //     setDp(url)
  //   })
  // },[])

  return (
    <div className='app_' style={{ backgroundColor: darkMode ? themeColors.darkOn.main.primary : themeColors.darkOff.main.primary, color: darkMode ? themeColors.darkOn.textColor : themeColors.darkOff.textColor, scrollbarWidth: 'none' }}>
      <div style={{ display: 'flex', height: dHeight }}>
        <div style={{ flex: .6, display: 'flex', flexDirection: 'column' }}>
          <div style={{ flex: .6, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', textAlign: 'center', borderBottom: `solid 1px ${darkMode ? themeColors.darkOn.bottomBorder : themeColors.darkOff.bottomBorder}` }}>
            <div style={{ height: 120, width: 120, borderRadius: '50%', border: `solid 1px ${darkMode ? themeColors.darkOn.main.secondary : themeColors.darkOff.main.secondary}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img alt="" src={dp} style={{ maxWidth: 110, borderRadius: '50%' }}>
              </img>
            </div>
            <p style={{ margin: 0, marginTop: 10, fontSize:14 }}>Brahm Harsh Parmar</p>
            <p style={{ margin: 0, margin: 5, fontSize:13 }}>Full Stack Developer</p>

            {/* <div style={{ color: darkMode ? themeColors.darkOn.iam : themeColors.darkOff.iam }}>
              <Typewriter
                options={{
                  strings: ['Full Stack Developer'],
                  autoStart: true,
                  loop: true,
                }}
              />
            </div> */}

          </div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <div onClick={() => setSection('work')} style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', backgroundColor: section === 'work' && darkMode ? themeColors.darkOn.main.secondary : darkMode === false && section === 'work' ? themeColors.darkOff.main.secondary : '', height: 35, width: 105, alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer', borderRadius: 5, paddingLeft:10, transition:"0.3s" }}>
                <MdWork style={{marginRight:10, fontSize:18}} />
                <p>Work</p>
              </div>
            </div>
            <div onClick={() => setSection('about')} style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', backgroundColor: section === 'about' && darkMode ? themeColors.darkOn.main.secondary : darkMode === false && section === 'about' ? themeColors.darkOff.main.secondary : '', height: 35, width: 105, alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer', borderRadius: 5, paddingLeft:10, transition:"0.3s" }}>
                <FaUserTie style={{marginRight:10, fontSize:18}} />
                <p>About me</p>
              </div>
            </div>
            <div onClick={() => setSection('resume')} style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', backgroundColor: section === 'resume' && darkMode ? themeColors.darkOn.main.secondary : darkMode === false && section === 'resume' ? themeColors.darkOff.main.secondary : '', height: 35, width: 105, alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer', borderRadius: 5, paddingLeft:10, transition:"0.3s" }}>
                <FaRegIdCard style={{marginRight:10, fontSize:18}} />
                <p>Resume</p>
              </div>
            </div>
            <div onClick={() => setSection('skills')} style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', backgroundColor: section === 'skills' && darkMode ? themeColors.darkOn.main.secondary : darkMode === false && section === 'skills' ? themeColors.darkOff.main.secondary : '', height: 35, width: 105, alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer', borderRadius: 5, paddingLeft:10, transition:"0.3s" }}>
                <GiSkills style={{marginRight:10, fontSize:18}} />
                <p>Skills</p>
              </div>
            </div>

            <div onClick={() => setSection('contact')} style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', backgroundColor: section === 'contact' && darkMode ? themeColors.darkOn.main.secondary : darkMode === false && section === 'contact' ? themeColors.darkOff.main.secondary : '', height: 35, width: 105, alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer', borderRadius: 5, paddingLeft:10, transition:"0.3s" }}>
                <MdPhoneInTalk style={{marginRight:10, fontSize:18}} />
                <p>Contact</p>
              </div>
            </div>
          </div>
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <div style={{ flex: .1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Toggle checked={darkMode} onChange={(e) => setDarkMode(e.target.checked)} />
            {
              darkMode ? <MdDarkMode fontSize={25}  style={{marginLeft:10}} />
              :
              <MdLightMode fontSize={25}  style={{marginLeft:10}} />
            }
          </div>
          <div style={{ flex: 1, display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.primary : themeColors.darkOff.container.primary, padding: 5, overflow: 'hidden', position: 'relative' }}>

            <div style={{ display: section === 'about' ? 'flex' : 'none', flex: 1 }}>
              <About hirebtn={() => setSection('contact')} themeColors={themeColors} darkMode={darkMode} />
            </div>
            <div style={{ display: section === 'resume' ? 'flex' : 'none', flex: 1 }}>
              <Resume themeColors={themeColors} darkMode={darkMode} />
            </div>
            <div style={{ display: section === 'skills' ? 'flex' : 'none', flex: 1 }}>
              <Skills themeColors={themeColors} darkMode={darkMode} />
            </div>
            <div style={{ display: section === 'work' ? 'flex' : 'none', flex: 1 }}>
              <Work themeColors={themeColors} darkMode={darkMode} />
            </div>
            <div style={{ display: section === 'contact' ? 'flex' : 'none', flex: 1 }}>
              <Contact themeColors={themeColors} darkMode={darkMode} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
